import {
  getDesktopDeviceResponse,
  printReportOnDesktop,
} from 'utility/desktopPrint.util'
import { sameDesktop } from 'utility/reportPrintConfig.util'

export const DESKTOP_TEST_PAGE_TEXT = 'Hello CK-Doctor Print Test Page'

const escapePdfText = (value) => value.replace(/[\\()]/g, '\\$&')

// A small, self-contained diagnostic PDF; no report rendering or backend is
// needed. Escaped Unicode keeps JSON values exact using PDF's standard fonts.
export const createDesktopPrintTestPageContent = (response) => {
  const json = JSON.stringify(response, null, 2)
  if (!json) throw new Error('ไม่พบข้อมูลเครื่องสำหรับหน้าทดสอบ')
  const asciiJson = json.replace(
    /[\u007f-\uffff]/g,
    (character) =>
      `\\u${character.charCodeAt(0).toString(16).padStart(4, '0')}`,
  )
  const lines = asciiJson
    .split('\n')
    .flatMap((line) => line.match(/.{1,90}/g) || [''])
  const pages = []
  for (let index = 0; index < lines.length; index += 59)
    pages.push(lines.slice(index, index + 59))
  const pageRefs = pages.map((_, index) => `${5 + index * 2} 0 R`)
  const objects = [
    '<< /Type /Catalog /Pages 2 0 R >>',
    `<< /Type /Pages /Kids [${pageRefs.join(' ')}] /Count ${pages.length} >>`,
    '<< /Type /Font /Subtype /Type1 /BaseFont /Courier >>',
    '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold >>',
  ]
  const text = (value, font, size, x, y) =>
    `BT /${font} ${size} Tf 1 0 0 1 ${x} ${y} Tm (${escapePdfText(
      value,
    )}) Tj ET`
  pages.forEach((page, index) => {
    const stream = [
      text(DESKTOP_TEST_PAGE_TEXT, 'F2', 16, 36, 800),
      text('GET /printers/device', 'F1', 9, 36, 780),
      ...page.map((line, lineIndex) =>
        text(line, 'F1', 9, 36, 756 - lineIndex * 12),
      ),
      text(`Page ${index + 1} / ${pages.length}`, 'F1', 8, 36, 28),
    ].join('\n')
    objects.push(
      `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 595.28 841.89] /Resources << /Font << /F1 3 0 R /F2 4 0 R >> >> /Contents ${
        6 + index * 2
      } 0 R >>`,
      `<< /Length ${stream.length} >>\nstream\n${stream}\nendstream`,
    )
  })
  let pdf = '%PDF-1.4\n'
  const offsets = [0]
  objects.forEach((object, index) => {
    offsets.push(pdf.length)
    pdf += `${index + 1} 0 obj\n${object}\nendobj\n`
  })
  const xref = pdf.length
  pdf += `xref\n0 ${objects.length + 1}\n0000000000 65535 f \n`
  offsets.slice(1).forEach((offset) => {
    pdf += `${String(offset).padStart(10, '0')} 00000 n \n`
  })
  pdf += `trailer\n<< /Size ${
    objects.length + 1
  } /Root 1 0 R >>\nstartxref\n${xref}\n%%EOF\n`
  return pdf
}

export const printDesktopTestPage = async ({ device, printerRefId }, url) => {
  if (!printerRefId) throw new Error('กรุณาเลือกเครื่องพิมพ์สำหรับทดสอบ')
  const response = await getDesktopDeviceResponse(url)
  if (response?.success === false)
    throw new Error(response.message || 'อ่านข้อมูล Desktop ไม่สำเร็จ')
  const current = response?.data ?? response
  if (!sameDesktop(device, current))
    throw new Error('เครื่อง Desktop เปลี่ยน กรุณาโหลดการตั้งค่าใหม่')
  const printers = Array.isArray(current?.printers) ? current.printers : []
  const printer = printers.find(
    (item) => (item.refId || item.name) === printerRefId,
  )
  if (!printer)
    throw new Error('ไม่พบเครื่องพิมพ์ที่เลือก กรุณาโหลดการตั้งค่าใหม่')
  if (
    ['offline', 'error', 'unavailable'].includes(
      String(printer.status).toLowerCase(),
    )
  ) {
    throw new Error('เครื่องพิมพ์ที่เลือกไม่พร้อมใช้งาน')
  }
  const blob = new Blob([createDesktopPrintTestPageContent(response)], {
    type: 'application/pdf',
  })
  return printReportOnDesktop(
    {
      ...(printer.refId
        ? { refId: printer.refId }
        : { printerName: printer.name }),
      blob,
      copies: 1,
      paperSize: 'A4',
    },
    url,
  )
}
